import linkViewModel from '@vimcar/mvvm/linkViewModel'
import Button from '@vimcar/shared-components/components/Button'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import RadioButtonGroup from '@vimcar/shared-components/components/RadioButtonGroup'
import cx from 'classnames'
import * as React from 'react'

import type { SelectNode } from '../../models/Nodes/SelectNode'
import type { ViewModel } from './viewModel'

import BottomActions from '../BottomActions'
import MultiLineButton from '../MultiLineButton'
import SearchField from '../SearchField'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  viewModel: ViewModel
  node?: SelectNode | null
}

const GenericOptionStep = ({ node, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph
        className={cx(
          {
            [styles.highlightText]: viewModel.ownNode.highlightText,
            [styles.centeredText]: viewModel.ownNode.centeredText,
          },
          styles.defaultWeight,
        )}
        variant={node ? 'subtitle2' : 'subtitle1'}
      >
        {viewModel.ownNode.text}
      </Paragraph>
      <Paragraph
        className={cx({
          [styles.centeredText]: viewModel.ownNode.centeredText,
        })}
        variant='body2'
      >
        {viewModel.ownNode.subtext}
      </Paragraph>
      {!viewModel.ownNode.disableSearch && !node && (
        <SearchField
          linkGroup={viewModel.ownNode.linkGroup}
          onChange={viewModel.handleSearchFormChange}
        />
      )}
      {/* @ts-expect-error@2339 */}
      {viewModel.options && (
        <React.Fragment>
          {viewModel.ownNode.radios && (
            <RadioButtonGroup
              className={styles.radioGroup}
              // @ts-expect-error@2322
              name='nextNodeId'
              onChange={viewModel.handleRadioChange}
              // @ts-expect-error@2339
              valueSelected={viewModel.nextNodeId}
            >
              {/* @ts-expect-error@2339 */}
              {viewModel.options.map((option) => (
                <RadioButtonGroup.RadioButton
                  disabled={!option.link}
                  key={option.id}
                  label={
                    option.text + (option.subtext ? `\n${option.subtext}` : '')
                  }
                  value={option.link && option.link.id}
                />
              ))}
            </RadioButtonGroup>
          )}
          <div className={styles.options}>
            {!viewModel.ownNode.radios &&
              // @ts-expect-error@2339
              viewModel.options.map((option) => (
                <React.Fragment key={option.id}>
                  {!viewModel.useMultilineButtons && (
                    <Button
                      className={styles.button}
                      disabled={!option.link}
                      // @ts-expect-error@2322
                      onClick={viewModel.handleClick(
                        option.link && option.link.id,
                      )}
                      raised
                      type='button'
                    >
                      {option.text}
                      {option.subtext && <br />}
                      {option.subtext}
                    </Button>
                  )}
                  {viewModel.useMultilineButtons && (
                    <MultiLineButton
                      className={styles.button}
                      disabled={!option.link}
                      onClick={
                        option.title.includes('LinkInteressent')
                          ? () => {
                              window.open(
                                'https://www.shiftmove.com/de/general-request',
                                '_blank',
                              )
                            }
                          : viewModel.handleClick(option.link && option.link.id)
                      }
                      subtext={option.subtext}
                      text={option.text}
                    />
                  )}
                </React.Fragment>
              ))}
          </div>
        </React.Fragment>
      )}
    </StepContent>
    {viewModel.showButtons && (
      <BottomActions
        // @ts-expect-error@2322
        nextEnabled={viewModel.isValid}
        onBack={viewModel.handleBack}
        onNext={viewModel.showContinue && viewModel.handleNext}
        showBack={viewModel.showBack}
      />
    )}
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, GenericOptionStep)
component.displayName = 'GenericOptionStep'
export default component
